import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=66bb6afb&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=66bb6afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb6afb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bb6afb')) {
      api.createRecord('66bb6afb', component.options)
    } else {
      api.reload('66bb6afb', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=66bb6afb&scoped=true&", function () {
      api.rerender('66bb6afb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zbk7CPKHE1II/JS/comp/PopupDialog.vue"
export default component.exports